import { VideoJob } from "@nova/protobuf"
import { entityValidator, enumValidator, UnionToTuple } from "../util"
import { dateAsNumber } from "../../util"
import { JobStatusType } from "@nova/constants"

export const createVideoJobValidator = entityValidator(VideoJob, {
    srtPath: {
        validators: [
            { validator: (srtPath) => srtPath.length > 0, error: "SRT path cannot be empty" },
        ],
    },
    videoPath: {
        validators: [
            { validator: (videoPath) => videoPath.length > 0, error: "Video path cannot be empty" },
        ],
        nonNull: true,
    },
    metadataPath: {
        validators: [
            {
                validator: (metadataPath) => metadataPath.length > 0,
                error: "Metadata path cannot be empty",
            },
        ],
    },
})

export const updateVideoJobValidator = entityValidator(VideoJob, {
    status: {
        validators: enumValidator("status", JobStatusType),
        nonNull: true,
    },
    resolutions: {
        validators: [],
        nonNull: true,
    },
})

export const getDefaultVideoJobCreateArgs = () => ({
    createdAt: dateAsNumber(),
    status: JobStatusType.COMPLETED,
    resolutions: [],
})

export type CreateVideoJobArgs = UnionToTuple<keyof typeof createVideoJobValidator>
export type UpdateVideoJobArgs = UnionToTuple<keyof typeof updateVideoJobValidator>
